import { render, staticRenderFns } from "./cadenas.vue?vue&type=template&id=13b0f59c&scoped=true"
import script from "./cadenas.vue?vue&type=script&lang=js"
export * from "./cadenas.vue?vue&type=script&lang=js"
import style0 from "./cadenas.vue?vue&type=style&index=0&id=13b0f59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0f59c",
  null
  
)

export default component.exports